import {
  buildWalletQueryParams,
  formatInvestmentTypeFilter,
} from '@modules/consolidator/utils/FormatWalletRequest/FormatWalletRequest.js'
import { MODO_TO_FILTER_PARAM } from '@modules/consolidator/utils/wallet-modo-configs/wallet-modo-configs'

const SENTINELS_WITHOUT_FILTER = new Set(['Consolidado', 'Todos', 'Todas'])

const BASE_DATA_REQUESTED = [
  'PL',
  'rentabilidade',
  'monthly_return',
  'statistics',
  'benchmarks',
  'posicao_completa',
  'posicao_expandida',
  'liquidez',
  'suitability',
]

const OFFSHORE_INCOMPATIBLE_FIELDS = ['evolucao_patrimonial']

const MULTI_FILTER_KEYS = [
  { input: 'tipo', output: 'tipo' },
  { input: 'subtipo', output: 'subtipo' },
  { input: 'classe', output: 'classe' },
  { input: 'subclasse', output: 'subclasse' },
  { input: 'setor', output: 'setor' },
  { input: 'emissor', output: 'emissor' },
  { input: 'idConta', output: 'id_conta' },
  { input: 'tags', output: 'tags' },
  { input: 'corretora', output: 'corretora' },
  { input: 'nome_portfolio', output: 'nome_portfolio' },
]

const GATEABLE_FILTER_KEYS = [
  'filtroCorretora',
  'investmentTypeFilter',
  'filtroData',
  'tipo',
  'subtipo',
  'classe',
  'subclasse',
  'setor',
  'emissor',
  'idConta',
  'tags',
  'corretora',
  'nome_portfolio',
]

export const buildWalletAnalysisRequest = ({
  idClienteApp,
  usuarioAtual,
  groupBy,
  filtroCorretora,
  modoFiltroCorretora,
  investmentTypeFilter,
  showCustomDate,
  filtroData,
  OPCOES_FILTRO_DATA,
  dataInicio,
  dataFim,
  dataRequested,
  enabledFieldKeys,
  tipo,
  subtipo,
  classe,
  subclasse,
  setor,
  emissor,
  idConta,
  tags,
  corretora,
  nome_portfolio,
} = {}) => {
  const gated = applyFieldWhitelist(
    {
      filtroCorretora,
      investmentTypeFilter,
      filtroData,
      tipo,
      subtipo,
      classe,
      subclasse,
      setor,
      emissor,
      idConta,
      tags,
      corretora,
      nome_portfolio,
    },
    enabledFieldKeys
  )

  const params = {
    id_cliente_app: idClienteApp,
    is_client: !!(usuarioAtual && usuarioAtual.IS_CLIENTE),
  }
  if (groupBy) params.group_by = groupBy

  const tipoInvestimento = formatInvestmentTypeFilter(gated.investmentTypeFilter)
  if (tipoInvestimento) params.investment_type = tipoInvestimento

  applyDateRange(params, {
    showCustomDate,
    filtroData: gated.filtroData,
    OPCOES_FILTRO_DATA,
    dataInicio,
    dataFim,
  })
  applyBrokerFilter(params, {
    filtroCorretora: gated.filtroCorretora,
    modoFiltroCorretora,
  })
  applyMultiFilters(params, {
    tipo: gated.tipo,
    subtipo: gated.subtipo,
    classe: gated.classe,
    subclasse: gated.subclasse,
    setor: gated.setor,
    emissor: gated.emissor,
    idConta: gated.idConta,
    tags: gated.tags,
    corretora: gated.corretora,
    nome_portfolio: gated.nome_portfolio,
  })

  const finalDataRequested = Array.isArray(dataRequested)
    ? dataRequested
    : resolveDataRequested({ investmentTypeFilter: gated.investmentTypeFilter })
  if (finalDataRequested.length > 0) {
    params.data_requested = finalDataRequested
  }

  return params
}

const applyFieldWhitelist = (inputs, enabledFieldKeys) => {
  if (!Array.isArray(enabledFieldKeys)) return inputs
  const allowed = new Set(enabledFieldKeys)
  const gated = { ...inputs }
  for (const key of GATEABLE_FILTER_KEYS) {
    if (!allowed.has(key)) gated[key] = null
  }
  return gated
}

const applyDateRange = (params, dateArgs) => {
  const dateParams = buildWalletQueryParams(dateArgs)
  if (dateParams.begin_date) params.start_date = dateParams.begin_date
  if (dateParams.end_date) params.end_date = dateParams.end_date
}

const applyBrokerFilter = (params, { filtroCorretora, modoFiltroCorretora }) => {
  if (!modoFiltroCorretora) return
  const values = normalizeBrokerInput(filtroCorretora)
  const filtered = values.filter((v) => !SENTINELS_WITHOUT_FILTER.has(v))
  if (filtered.length === 0) return
  const key = MODO_TO_FILTER_PARAM[modoFiltroCorretora] || 'corretora'
  params[key] = filtered
}

const normalizeBrokerInput = (filtroCorretora) => {
  if (Array.isArray(filtroCorretora)) return filtroCorretora
  if (filtroCorretora === null || filtroCorretora === undefined || filtroCorretora === '') {
    return []
  }
  return [filtroCorretora]
}

const resolveDataRequested = ({ investmentTypeFilter }) => {
  if (investmentTypeFilter === 'offshore') return [...BASE_DATA_REQUESTED]
  return [...BASE_DATA_REQUESTED, ...OFFSHORE_INCOMPATIBLE_FIELDS]
}

const applyMultiFilters = (params, args) => {
  for (const { input, output } of MULTI_FILTER_KEYS) {
    const value = args[input]
    if (Array.isArray(value) && value.length > 0) {
      params[output] = value
    }
  }
}
